import { createContext, useContext, useEffect, useMemo, useState } from "react";

const STORAGE_KEY = "barberiant_branding";
export const defaultBranding = { name: "Barberiant", tagline: "Barberia y gestion", primary: "#c52b31", accent: "#c9a96e", dark: "#0c0c0d", logoUrl: "", title: "Barberiant", faviconUrl: "" };
const BrandingContext = createContext(null);

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(() => { try { return { ...defaultBranding, ...JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}") }; } catch { return defaultBranding; } });
  useEffect(() => { localStorage.setItem(STORAGE_KEY, JSON.stringify(branding)); const root = document.documentElement; root.style.setProperty("--brand-primary", branding.primary); root.style.setProperty("--brand-accent", branding.accent); root.style.setProperty("--brand-dark", branding.dark); document.title = branding.title || branding.name; let favicon = document.querySelector("link[rel=\"icon\"]"); if (!favicon) { favicon = document.createElement("link"); favicon.rel = "icon"; document.head.appendChild(favicon); } if (branding.faviconUrl) favicon.href = branding.faviconUrl; }, [branding]);
  const updateBranding = (patch) => setBranding((current) => ({ ...current, ...patch }));
  const resetBranding = () => setBranding(defaultBranding);
  const value = useMemo(() => ({ branding, updateBranding, resetBranding }), [branding]);
  return <BrandingContext.Provider value={value}>{children}</BrandingContext.Provider>;
}
export const useBranding = () => useContext(BrandingContext);




